"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileUploadOptions = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _once = _interopRequireDefault(require("transmute/once"));

var getFolderPaths = function getFolderPaths() {
  return "email-attachments/" + _I18n.default.moment().format('YYYY/MM/DD');
};

var getFileUploadOptions = (0, _once.default)(function () {
  return {
    query: {
      hidden: true
    },
    formData: {
      getFolderPaths: getFolderPaths
    }
  };
});
exports.getFileUploadOptions = getFileUploadOptions;